import { RequestedStopInventory, RequestedStopInventoryWrite, } from './RequestedStopInventory';
export class RequestedStopWrite {
    constructor(json) {
        this.id = json.id;
        this.locationId = json.location_id;
        this.position = json.position;
        this.inventory = json.requested_inventory.map((item) => new RequestedStopInventoryWrite(item));
        this.stopType = json.stop_type;
    }
}
export class RequestedStop extends RequestedStopWrite {
    constructor(json) {
        super(json);
        this.locationName = json.location_name;
        this.locationOwnerId = json.location_owner_id;
        this.inventory = json.requested_inventory.map((item) => new RequestedStopInventory(item));
    }
}
//# sourceMappingURL=RequestedStop.js.map